import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';
import { StyledTableContainer } from 'helpers/StyledTableComponentsHelper';

class TableWithoutFilters extends Component {
  render() {
    const { data, columns } = this.props;

    return (
      <StyledTableContainer>
        {this._renderDesktopView({ data, columns })}
        {this._renderMobileView({ data, columns })}
      </StyledTableContainer>
    );
  }

  _renderDesktopView = ({ data, columns }) => (
    <MediaQuery query="(min-device-width: 750px)">
      <TabbedTable
        tabs={[]}
        setRef={this.props.setRef}
        groupRowsBy={this.props.groupRowsBy}
        columns={columns}
        data={data}
        searchTotalResultsCount={this.props.searchTotalResultsCount}
        loadMoreData={this.props.fetchFilteredData}
        isLoading={this.props.isLoading}
        filtersActive={false}
        onRowClick={this.props.onRowClick}
        onColumnClick={data => this.props.handleSort(data.key, data.order)}
        emptyTableText={this.props.emptyTableText}
      />
    </MediaQuery>
  );

  _renderMobileView = ({ data, columns }) => (
    <MediaQuery query="(max-device-width: 750px)">
      <MobileTable
        groupRowsBy={this.props.groupRowsBy}
        data={data}
        columns={columns}
        title={this.props.mobileTableTitle}
        tag="status"
        rowHeader={this.props.rowHeader}
        stickyHeaderTop="0px"
        isLoading={this.props.isLoading}
        onRowClick={this.props.onRowClick}
        fieldsAboveFold={this.props.fieldsAboveFold}
        fieldsBelowFold={this.props.fieldsBelowFold}
        emptyTableText={this.props.emptyTableText}
      />
    </MediaQuery>
  );
}

export default withMobileDialog()(TableWithoutFilters);
